//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import HiCell from "../../cell/Index.vue";
import { mapGetters } from "vuex";
import { CURRENT_USER_INFO_SIMPLE } from "../../../store/mutation-types";
import Confirm from "../../confirm/Index.vue";
import MemberDes from "../../team_member/des/Index.vue";

export default {
  name: "PlanTeamMemberComponent",
  components: { HiCell, Confirm, MemberDes },
  data() {
    return {
      memberDesOpen: false,
    };
  },
  methods: {
    /**
     * 点击跳转到member设置页面
     */
    memberDetailClick(item) {
      this.$router.push({
        name: "MyPlanMemberDetailPage",
        params: { id: item.id },
      });
    },
    /**
     * 跳转到验证页面
     */
    async inviteMemberClick() {
      // if (this.user.memberRemaining === 0) {
      //   // 并彈出升級提示
      //   await this.$confirm.show({
      //     text: this.$t('myPlanPage.teamMember.upgradeText'),
      //     yesText: this.$t('common.upgrade')
      //   })
      //   this.$router.push({name: 'PaymentUpgradePage', params: {type: 'filter'}})
      //   return
      // }
      this.$router.push({ name: "TeamMemberInviteMemberPage" });
    },
    /**
     * 跳转到member 更多页面
     */
    moreMemberClick() {
      this.$router.push({ name: "TeamMemberListPage" });
    },
  },
  computed: {
    ...mapGetters({
      user: CURRENT_USER_INFO_SIMPLE,
    }),
    /**
     * member标题
     */
    memberTitle() {
      let title = this.$t("inviteMemberPage.pageTitle");
      if (this.maxMember > 0) {
        title += ` (${this.user.teamMemberList.length}/${this.maxMember})`;
      }
      return title;
    },
    /**
     * 计算列表
     * @returns {Array}
     */
    member() {
      if (this.user.teamMemberList.length > 0) {
        const firstMember = this.user.teamMemberList[0];
        return {
          id: firstMember.id,
          username: firstMember.memberEmail,
        };
      } else {
        return null;
      }
    },
    /**
     * 计算最多Member数量
     */
    maxMember() {
      return this.user.plan.memberCount;
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/plan/team_member/Index.vue